module["exports"] = [
  "فیستا",
  "فوکوس",
  "تاروس",
  "موستانگ",
  "اکسپلورر",
  "کروز",
  "مالیبو",
  "ایمپالا",
  "کامارو",
  "کروت",
  "کولورادو",
  "سیلورادو",
  "اسکالید",
  "آلپاین",
  "چارجر",
  "چلنجر",
  "رانگلر",
  "گرند چروکی",
  "رودستر",
  "کمری",
  "پریوس",
  "لندکروزر",
  "آکورد",
  "سیویک",
  "المنت",
  "سنترا",
  "آلتیما",
  "یبتل",
  "جتا",
  "گلف",
  "911",
  "اسپایدر",
  "کونتاچ",
  "مورسیه لاگو",
  "اونتادور",
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/vehicle/model.js
// module id = 2915
// module chunks = 1610